import { AsyncStoreItem } from '@lib/store';
import { GetOrderListResponse } from 'src/sdk-servicing';

/**
 * GetOrderList model
 */
export interface GetOrderListModel {
  model: GetOrderListResponse | null;
}

/**
 * GetOrderListResponse model details
 */
export interface GetOrderListStateDetails extends AsyncStoreItem {}

/**
 * GetOrderList store state
 */
export interface GetOrderListState extends GetOrderListStateDetails, GetOrderListModel {}

/**
 * Name of the GetOrderList Store
 */
export const GET_ORDER_LIST_STORE_NAME = 'getOrderList';

/**
 * GetOrderList Store Interface
 */
export interface GetOrderListStore {
  /** GetOrderList state */
  [GET_ORDER_LIST_STORE_NAME]: GetOrderListState;
}
